import React from 'react';

const ProductCard = ({ title, subtitle, features, onClick, icon, isPremium = false, variant = null, buttonLabel = 'Get Cover' }) => {
  return (
    <div className={`product-card ${isPremium ? 'premium' : ''} ${variant === 'extend' ? 'product-card-extend' : ''}`}>
      {/* Premium badge positioned at top-right corner */}
      {isPremium && (
        <div className="premium-badge">
          <span className="badge-icon">⭐</span>
          PREMIUM
        </div>
      )}
      
      {/* Card header with icon and title */}
      <div className="card-header">
        <div className="icon-container">
          <span className="card-icon">{icon}</span>
        </div>
        <h3 className="card-title">{title}</h3>
        <p className="card-subtitle">{subtitle}</p>
      </div>
      
      {/* Card content with features */}
      <div className="card-content">
        <div className="features-list">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <span className="feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <span className="feature-text">{feature}</span>
            </div>
          ))}
        </div>
      </div>
      
      {/* Card footer with CTA button */}
      <div className="card-footer">
        <button className="btn-select" onClick={onClick}>
          <span>{buttonLabel}</span>
          <span className="arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
